import type Victor from 'victor';
import type { BezierLine } from '@model-framework/link/BezierLine/BezierLine';
import type { Rect } from '@view-model/models/common/basic/Rect';
import { StickyNode } from '@view-model/models/sticky/StickyNodeView';
import { buildLinkBezierLine } from './linkBezierLine';

export class BezierQuadraticFactory {
  static buildBezierLine(srcRect: Rect, dstRect: Rect, bendingPoint: Victor, offset = 64): BezierLine {
    return buildLinkBezierLine(srcRect, dstRect, bendingPoint, offset, StickyNode.size());
  }
}
